var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vue-modal"},[_c('button',{staticClass:"close-button",attrs:{"type":"button"},on:{"click":function($event){return _vm.$emit('close')}}},[_c('span',{staticClass:"visually-hidden"},[_vm._v("Sluiten")])]),_vm._v(" "),_c('div',{staticClass:"modal-content",domProps:{"innerHTML":_vm._s(_vm.content)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }